import ContentBasedImage from '@/../public/_n/images/onboarding/SleepLayeredContent.png';
import { AccountScreenConfig } from '@/components/SimplifiedSignup/Account/types';
import AdditionalContent from '@/components/SimplifiedSignup/Components/AdditionalContent';
import { HandoffScreenConfig } from '@/components/SimplifiedSignup/Handoff/types';
import { PaymentScreenConfig } from '@/components/SimplifiedSignup/Payment/types';

import blogMessages from '../Blog-Discount-Offer/messages';
import { accountValueProps } from '../Blog-Discount-Offer/Screens';
import ControlScreenConfigs from '../Control/Screens';
import messages from './messages';

const MonthlyOfferAccountScreenConfig: AccountScreenConfig = {
	...ControlScreenConfigs.account,
	upsellBullets: accountValueProps,
	upsellHeader: () => ({ message: messages.accountValuePropHeader }),
	showHeader: false,
	heading: ({ authFormMode, prices, purchaseParams }) => {
		if (authFormMode === 'login') {
			return { message: messages.loginFormHeading };
		}

		const percentOff = prices?.coupons?.[purchaseParams?.plan || 'yearly']?.percent_off;

		if (percentOff && percentOff > 0) {
			return {
				message: messages.signupFormHeading,
				placeholders: {
					percentOff: percentOff.toString(),
				},
			};
		}

		return { message: messages.signupFormHeadingNoDiscount };
	},
	AdditionalContent: () => <AdditionalContent />,
	contentBasedImage: {
		src: ContentBasedImage,
	},
};
const MonthlyOfferPaymentScreenConfig: PaymentScreenConfig = {
	...ControlScreenConfigs.payment,
	limitedTimeOffer: false,
	showHeader: false,
	heading: () => ({ message: messages.accountValuePropHeader }),
	showToggle: false,
	terms: messages.terms,
	offerTerms: messages.offerTerms,
	contentBasedImage: {
		src: ContentBasedImage,
	},
};
const MonthlyOfferHandoffScreenConfig: HandoffScreenConfig = {
	...ControlScreenConfigs.handoff,
	CTA: {
		onClick: async routerPush => {
			await routerPush('/app');
		},
		label: blogMessages.handoffCTALabel,
		href: '/app',
	},
};

export default {
	account: MonthlyOfferAccountScreenConfig,
	payment: MonthlyOfferPaymentScreenConfig,
	handoff: MonthlyOfferHandoffScreenConfig,
};
